import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Col, Row, Typography } from "antd";
import Image from "next/image";
import React from "react";
import { useIntl } from "react-intl";
import { IBookedTrips, ITripItemProps } from "../../Orchestrator/Types/Index";
import {
  calculateAgeGroup,
  translateDuration,
} from "../../Lib/Utils/validationUtil";
import stopManager from "../../Lib/Utils/StopManager";

const TripItem: React.FC<ITripItemProps> = ({
  trip,
  onShowModal,
  type,
  isInbound = false,
}) => {
  const intl = useIntl();

  return (
    <div className="trip-trip-info">
      <Row>
        <Col span={2} className="d-flex justify-content-center">
          <div className="icon">
            <Image
              src="/assets/my_account/arrow_forward.png"
              width={14}
              height={14}
              alt="train"
              className="ml-10 mr-10"
            />
          </div>
        </Col>
        <Col span={22}>
          <div>
            <div className="align-items-center">
              <Typography.Text className="fs-16 fw-700">
                {stopManager.getStopNameById(isInbound ? trip.to : trip.from)}
                <Image
                  src="/assets/booking/arrow-right.svg"
                  width={20}
                  height={20}
                  alt="one way"
                  className="right-arrow"
                />
                {stopManager.getStopNameById(isInbound ? trip.from : trip.to)}
              </Typography.Text>
            </div>

            {"departureTime" in trip && (
              <>
                <Typography.Text className="fs-15 fw-700">
                  {isInbound
                    ? trip.inboundData.departureTime
                    : trip.departureTime}{" "}
                  {" - "}
                  {isInbound ? trip.inboundData.arrivalTime : trip.arrivalTime}
                </Typography.Text>
                <Typography.Text className="d-block fs-14 fw-500 color-757575 mt-10">
                  {translateDuration(
                    isInbound ? trip.inboundData.duration : trip.duration || "",
                    intl
                  )}{" "}
                  &#9679;{" "}
                  {/* {trip.stops.length > 0
                    ? `${trip?.stops?.length} Stop(s)`
                    : intl.formatMessage({ id: "direct" })}{" "} */}
                  {/* `stops` here holds one entry per change of train */}
                  {(isInbound ? trip?.inboundData?.stops : trip?.stops)
                    ?.length > 0
                    ? intl.formatMessage(
                        { id: "transferCount" },
                        { count: (isInbound ? trip?.inboundData?.stops : trip?.stops)?.length }
                      )
                    : intl.formatMessage({ id: "direct" })}{" "}
                  &#9679; {trip.trainNumber} &#9679;{" "}
                  {calculateAgeGroup(trip.passengers, intl)}
                </Typography.Text>
              </>
            )}

            {/* {isLastSearchedTrip(trip) && (
              <>
                <Typography.Text
                  type="secondary"
                  className="d-block mt-5 fs-20 fw-400 ff-inter color-2F3034"
                >
                  {trip.date}
                </Typography.Text>
                <Typography.Text
                  type="secondary"
                  className="d-block mt-2 fs-16 fw-500 ff-inter color-757575"
                >
                  {trip.passengers}
                </Typography.Text>
              </>
            )} */}
          </div>
        </Col>
      </Row>
      <div className="d-flex justify-content-between align-items-center">
        {type !== "selected" && (
          <Button
            type="default"
            shape="circle"
            onClick={() => onShowModal(trip as IBookedTrips)} // Pass the trip when clicking the button
            icon={
              intl?.locale === "ar" ? (
                <LeftOutlined className="w-18 h-18" />
              ) : (
                <RightOutlined className="w-18 h-18" />
              )
            }
            className="h-auto w-auto p-10 bg-F3E6DD color-2F3034 border-color-transparent"
          />
        )}
      </div>
    </div>
  );
};

export default TripItem;
